import { render, staticRenderFns } from "./PurchaseInboxreaderSettingsEditMailboxAlias.vue?vue&type=template&id=9ab93a58&scoped=true"
import script from "./PurchaseInboxreaderSettingsEditMailboxAlias.vue?vue&type=script&lang=ts"
export * from "./PurchaseInboxreaderSettingsEditMailboxAlias.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseInboxreaderSettingsEditMailboxAlias.vue?vue&type=style&index=0&id=9ab93a58&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab93a58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ab93a58')) {
      api.createRecord('9ab93a58', component.options)
    } else {
      api.reload('9ab93a58', component.options)
    }
    module.hot.accept("./PurchaseInboxreaderSettingsEditMailboxAlias.vue?vue&type=template&id=9ab93a58&scoped=true", function () {
      api.rerender('9ab93a58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/PurchaseInboxreaderSettingsEditMailboxAlias.vue"
export default component.exports